import {LexicalEditor} from 'lexical';
import {$generateHtmlFromNodes} from '@lexical/html';
import DOMPurify from 'dompurify';

export const modifyHtmlList = (htmlString, isRTL) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    doc.querySelectorAll('ol, ul').forEach(el => {
        el.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
    });

    return doc.body.innerHTML;
};

export const getHtmlContent = async (
    editor: LexicalEditor,
    callback?: (html: string) => void,
    isRTL = false
): Promise<string> => {
    return new Promise((resolve, reject) => {
        if (!editor) {
            reject('Editor instance is missing');
        }
        editor.getEditorState().read(() => {
            const res = DOMPurify.sanitize($generateHtmlFromNodes(editor), {
                FORBID_ATTR: ['class'],
                ADD_ATTR: ['_field_data']
            });
            /*
             * Thar's a default structure generated by lexical package for
             * empty editor state, it's might be fixed in the upcoming releases
             */
            const validatedHTML = res === '<p><br></p>' ? '' : modifyHtmlList(res, isRTL);
            if (callback) {
                callback(validatedHTML);
            }

            resolve(validatedHTML);
        });
    });
};
